module.exports = __webpack_public_path__ + "img/cadastral-pin.6de1530a.svg";